import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-maintenance",
  standalone: true,
  imports: [RouterLink],
  templateUrl: "./maintenance.component.html",
  styleUrl: "./maintenance.component.scss",
})
export class MaintenanceComponent {}
